import { FileStatus } from 'utilities'

export enum AspectTypes {
  PORTRAIT = 'portrait',
  SQUARE = 'square'
}

export interface MediaContentDTO {
  contentType: string
  id: number
  label: string
  mainImage: boolean
  originalHeight: number
  originalWidth: number
  portrait: boolean
  portraitWidth: number
  portraitX: number
  portraitY: number
  square: boolean
  squareWidth: number
  squareX: number
  squareY: number
  url: string
}

export interface GalleryImage extends Partial<MediaContentDTO> {
  src: string | ArrayBuffer
  status: FileStatus
  file?: File
}

export class Image {
  id: number
  contentType: string
  url: string
  originalWidth: number
  originalHeight: number
  label: string
  mainImage: boolean
  portraitWidth: number
  portraitX: number
  portraitY: number
  squareWidth: number
  squareX: number
  squareY: number
  portrait: boolean
  square: boolean

  constructor (image: Image) {
    for (const property in image) {
      this[property] = image[property]
    }
  }
}
